import {z} from 'zod';

export const abraFormSchema = z.object({
  abraAccount: z.string().min(1),
  abraCompany: z.string().min(1),
  mappingMethod: z.string().min(1),
  username: z.string().min(1),
  password: z.string().min(1),
});

export type AbraFormValues = z.infer<typeof abraFormSchema>;
